module.exports = __webpack_public_path__ + "img/logo.c242aaa8.svg";